export const FLITCH_EXPENSES_REQUEST = "FLITCH_EXPENSES_REQUEST";
export const FLITCH_EXPENSES_SUCCESS = "FLITCH_EXPENSES_SUCCESS";
export const FLITCH_EXPENSES_FAILED = "FLITCH_EXPENSES_FAILED";
